import { render, staticRenderFns } from "./GameStrategy2.vue?vue&type=template&id=74319d5a&scoped=true&"
import script from "./GameStrategy2.vue?vue&type=script&lang=js&"
export * from "./GameStrategy2.vue?vue&type=script&lang=js&"
import style0 from "./GameStrategy2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameStrategy2.vue?vue&type=style&index=1&id=74319d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74319d5a",
  null
  
)

export default component.exports